import React from 'react';
import { ClientPageLayout } from '@/components/client/shared/ClientPageLayout';
import { ClientTracesView } from '@/components/client/ClientTracesView';
import { Badge } from '@/components/ui/badge';

/**
 * Página principal para mostrar las llamadas (traces) del cliente
 * Solo visible para usuarios con bots de tipo 'voicebot'
 */
export function ClientTraces() {
  return (
    <ClientPageLayout
      title="Llamadas"
      subtitle="Historial y análisis detallado de llamadas"
      actions={
        <Badge variant="secondary" className="animate-pulse">
          BETA
        </Badge>
      }
    >
      <ClientTracesView />
    </ClientPageLayout>
  );
}